module.exports = __webpack_public_path__ + "static/img/sunset.12f0f8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sunset.jpg
// module id = PBjM
// module chunks = 0